import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { HorizonHeatMap, HorizonHeatMapNode } from '@modules/leads-management/lead-horizon-tracking/lead-horizon-tracking.model';

/**
 * HorizonHeatMapComponent
 *
 * Draws a Horizon heat map: the image the backend supplies with a hotspot (and optional outline)
 * for every node. Coordinates arrive as percentages of the image, so the map scales to any width.
 * Nodes that open a deeper level (`drill_to`) emit `nodeSelected`; the host decides what to load.
 */
@Component({
  selector: 'app-horizon-heat-map',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './horizon-heat-map.component.html',
  styleUrls: ['./horizon-heat-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HorizonHeatMapComponent {
  @Input() heatMap: HorizonHeatMap | null = null;
  @Output() nodeSelected = new EventEmitter<HorizonHeatMapNode>();

  /** Without an image the percentages have nothing to sit on, so the box keeps the backend's aspect ratio. */
  get aspectRatio(): string {
    return this.heatMap?.image_width && this.heatMap?.image_height ? `${this.heatMap.image_width} / ${this.heatMap.image_height}` : '16 / 10';
  }

  points(node: HorizonHeatMapNode): string {
    return (node.polygon ?? []).map(([x, y]) => `${x},${y}`).join(' ');
  }

  select(node: HorizonHeatMapNode): void {
    if (node.drill_to) {
      this.nodeSelected.emit(node);
    }
  }

  trackByNodeId(_: number, node: HorizonHeatMapNode): string {
    return node.id;
  }
}
